import BaseModal from "./base_modal"
import { fetchWithCsrf } from "../util"

export default class CompleteNameModal extends BaseModal {
  constructor(updateUrl) {
    super()
    this.updateUrl = updateUrl
  }

  modalId() {
    return "complete-name-modal"
  }

  bindEvents() {
    const modal = this.modalElement()

    modal.querySelector("[data-modal-submit]").addEventListener("click", (event) => {
      event.preventDefault()
      this.submitName()
    })
  }

  submitName() {
    const firstName = this.firstNameInput().value.trim()
    const lastName = this.lastNameInput().value.trim()

    if (!this.validateInputs(firstName, lastName)) return

    this.saveName(firstName, lastName)
  }

  saveName(firstName, lastName) {
    fetchWithCsrf(this.updateUrl, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: JSON.stringify({ user: { name: firstName, last_name: lastName } })
    })
      .then((response) => {
        if (response.ok) {
          response.text().then((html) => Turbo.renderStreamMessage(html))
          this.dismiss()
        } else {
          return response.json().then((data) => {
            this.showFieldError("complete-name-server-error", data.error || "Something went wrong")
          })
        }
      })
  }

  validateInputs(firstName, lastName) {
    this.clearErrors()

    let valid = true

    if (!firstName) {
      this.showFieldError("complete-name-first-name-error", "First name is required")
      valid = false
    }

    if (!lastName) {
      this.showFieldError("complete-name-last-name-error", "Last name is required")
      valid = false
    }

    return valid
  }

  showFieldError(elementId, message) {
    const errorElement = document.getElementById(elementId)
    if (errorElement) {
      errorElement.textContent = message
      errorElement.classList.remove("hidden")
    }
  }

  clearErrors() {
    const errorElements = this.modalElement().querySelectorAll(".field-error")
    errorElements.forEach((element) => {
      element.textContent = ""
      element.classList.add("hidden")
    })
  }

  firstNameInput() {
    return document.getElementById("complete-name-first-name")
  }

  lastNameInput() {
    return document.getElementById("complete-name-last-name")
  }

  modalHTML() {
    return `
      <div id="complete-name-modal"
           class="fixed inset-0 z-50 flex items-center justify-center bg-darkblue/60"
           aria-hidden="false">
        <div class="modal-wrapper relative">
          <div class="modal-container modal-container--md">
            <div class="modal-content modal-section ui-gap-lg">
              <div class="flex flex-col ui-gap-xs leading-20">
                <p class="font-semibold leading-20 text-lg">
                  Complete Your Name
                </p>
                <p class="leading-20">
                  Please enter your first and last name to continue.
                </p>
              </div>

              <div class="flex flex-col gap-15">
                <div class="flex flex-col gap-5">
                  <label for="complete-name-first-name" class="text-sm font-medium">First Name</label>
                  <input type="text"
                         id="complete-name-first-name"
                         class="form-input form-input--md"
                         placeholder="Enter your first name" />
                  <span id="complete-name-first-name-error" class="field-error text-chilired text-sm hidden"></span>
                </div>

                <div class="flex flex-col gap-5">
                  <label for="complete-name-last-name" class="text-sm font-medium">Last Name</label>
                  <input type="text"
                         id="complete-name-last-name"
                         class="form-input form-input--md"
                         placeholder="Enter your last name" />
                  <span id="complete-name-last-name-error" class="field-error text-chilired text-sm hidden"></span>
                </div>

                <span id="complete-name-server-error" class="field-error text-chilired text-sm hidden"></span>
              </div>
            </div>

            <div class="modal-section">
              <button type="button"
                      data-modal-submit
                      class="btn-orange-md w-200! mx-auto">
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    `
  }
}
